import React, { useRef, useState, useEffect, memo } from "react";
import { eyeSeen, eyeSeenFocus, eyeUnseen, eyeUnseenFocus, backIcon2, lockIcon } from "../../../../Image/Index";
import Header from "../../../layout/Header";
import { ValidatorForm } from "react-form-validator-core";
import { Link, useNavigate } from "react-router-dom";
import { campaign, schema, UpdateCampaign } from "../services";
import { Token_Generator } from "../../../../actions/auth";
import { getDate, parseNumeric, selectValueGetter, selectValueGetterBoolean, getOperator } from "../../../../utils/helper";
import Switch from "react-switch";
import TextValidator from "../../../partial/TextValidator";
import SelectValidator from "../../../partial/SelectValidator";
import respone from "../reqbody.json";
import swal from 'sweetalert';

const CreateSignupRuleTab = memo(() => {
	const formRef = useRef();
	const [loader, setLoader] = useState(false);
	const navigate = useNavigate();
	const [formData, setFormData] = useState(respone);
	const [newData, setNewData] = useState({ ...formData });
	const [data, setData] = useState({
		startdate: "",
		enddate: "",
		value: "",
		rewardratio: "",
		after: true,
		afterSpecificNumber: "",
		afterDay: "",
		onspecificdate: "",
		merchantId: localStorage.getItem("Id"),
		schemaId: localStorage.getItem("schemaId"),
		schemaName: localStorage.getItem("schemaName"),
	});

	const [option, setOptions] = useState({
		optionPoint: [
			{ value: "Fix-Point", label: "Fix- Point" },
			{ value: "Percentage-Point", label: "Percentage-Point" },
		],
		optionOnAfter: [
			{ value: true, label: "On" },
			{ value: false, label: "After" },
		],
		optionAfter: [{ value: "Day(s)", label: "Day(s)" }],
		transactionOption: [],
		amountOption: [],
		conditions: [],
	});

	useEffect(() => {
		setFormData({
			...formData,
			merchantTransactionSchema: {
				schemaId: data.schemaId,
				schemaName: data.schemaName,
				merchants: [data.merchantId],
			},
			startDateTime: data.startdate,
			merchantId: [data.merchantId],
			endDateTime: data.enddate,
			earningRule: {
				rules: [
					{
						...formData.earningRule.rules[0],
						data: [
							{
								...formData.earningRule.rules[0].data[0],
								Value: +data.value,
								RewardRatio: +data.rewardratio,
								expirationRule: data.after
									? {
											// ...formData.earningRule.rules[0].data[0].expirationRule,
											afterDuration: data.afterDay,
											afterSpecificNumber: data.afterSpecificNumber,
											onAfter: data.after,
									  }
									: {
											...formData.earningRule.rules[0].data[0].expirationRule,
											onAfter: data.after,
											onSpecificDate: data.onspecificdate,
											onAfterSame: false,
									  },
							},
						],
					},
				],
			},
		});
	}, [data]);
	const onSubmit = async () => {
		campaignCreator();
	};

	const campaignCreator = async () => {
		setLoader(true);
		const token = JSON.parse(localStorage.getItem("token_gen"));
		const response = await campaign(token?.access_token, formData);
		if (response.message === "Record Created Successfully.") {
			setLoader(false);
			swal({
                position: 'center',
                icon: 'success',
                title: 'Create Campaign Successfully.',
                showConfirmButton: false,
                timer: 5000,
            });   
			navigate("/my-campaigns");
		} else {
			setLoader(false);
			swal({  
                title: " Oops!",  
                text: " Something went wrong please try again.",  
                icon: "error",  
                button: "oh no!",
                timer: 5000,  
              });  
		}
	};
	const onChange = (e) => {
		setData({ ...data, [e.target.name]: e.target.value });
	};
	const onChangeSelect = (e) => {
		setData({ ...data, afterDay: e.value });
	};
	const onChangeAfterSelect = (e) => {
		setData({ ...data, after: e.value });
	};
	const onCancel = () => {
		setData({ ...data, startdate: "", enddate: "", value: "", rewardratio: "", after: true, afterSpecificNumber: "", afterDay: "", onspecificdate: "" });
	};

	return (
		<>
			<Header name={"Signup Rewards"} />
			{loader && (
				<div className="mainPreloaderMain">
					<div className="mainPreloader">
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}
			<div className="dashboard__content">
				<div className="container-fluid">
					<div className="dashboard__profileSettingsMain">
						<div className="dashboard__heading">
							<div className="dashboard__headingLeft">
								<div className="dashboard__headingBackLink">
									<Link to="" onClick={() => navigate(-1)}>
										<img src={backIcon2} alt="" />
									</Link>
								</div>
								<div className="dashboard__headingContent">
									<h3>Create Signup campaign</h3>
								</div>
							</div>
						</div>
						<div className="dashboard__profileSettingsBox">
							<ValidatorForm className="customForm" ref={formRef} onSubmit={() => onSubmit()}>
								<div className="row">
									<div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
										<div className="form-group">
											<label>Start date</label>
											<TextValidator
												type="date"
												validators={["required"]}
												min={getDate(new Date(), "YYYY-MM-DD")}
												errorMessages={["Please select a date "]}
												value={data.startdate}
												className="form-control"
												name="startdate"
												onChange={onChange}
												//    onClick={handleClick}
											/>
										</div>
									</div>

									<div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
										<div className="form-group">
											<label>End Date</label>
											<TextValidator
												type="date"
												className="form-control"
												name="enddate"
												value={data.enddate}
												onChange={onChange}
												validators={["required"]}
												errorMessages={["Please select a date "]}
												min={getDate(data.startdate, "YYYY-MM-DD")}
												//    onClick={handleClick}
											/>
										</div>
									</div>
									<div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
										<div className="form-group">
											<label>value</label>
											<TextValidator
												placeholder="value"
												className="form-control"
												name="value"
												onChange={onChange}
												value={data.value}
												validators={["required", "matchRegexp:^[1-9][0-9]*$"]}
												errorMessages={["Field can't be empty", "please enter a valid value"]}

												//    onClick={handleClick}
											/>
										</div>
									</div>
									<div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
										<div className="form-group">
											<label>Reward Ratio</label>
											<TextValidator
												placeholder="Reward-ratio"
												className="form-control"
												name="rewardratio"
												onChange={onChange}
												value={data.rewardratio}
												validators={["required", "matchRegexp:^[1-9][0-9]*$"]}
												errorMessages={["Field can't be empty", "please enter a valid value"]}

												//    onClick={handleClick}
											/>
										</div>
									</div>
									<div className="col-sm-12 col-md-12 col-lg-12">
										<div className="dashboard__customFormBox">
											<div className="dashboard__heading">
												<div className="dashboard__left">
													<h5>Expiration</h5>
												</div>
											</div>
											<div className="dashboard__customFormCard">
												<div className="dashboard__middle">
													<div className="row">
														<div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
															<div className="form-group">
																<label>On / After</label>
																<SelectValidator placeholder="Select" className="custom-ReactSelect bordered" name="after" validators={["required"]} errorMessages={["Please select a value "]} value={selectValueGetterBoolean(option.optionOnAfter, data.after)} options={option.optionOnAfter} onChange={onChangeAfterSelect} />
															</div>
														</div>
														{data.after ? (
															<>
																<div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
																	<div className="form-group">
																		<label>Number</label>
																		<TextValidator
																			placeholder="no. of days"
																			className="form-control"
																			name="afterSpecificNumber"
																			validators={["required", "matchRegexp:^[1-9][0-9]*$"]}
																			errorMessages={["Field can't be empty", "please enter a valid value"]}
																			value={data.afterSpecificNumber}
																			// onChange={(e) =>
																			//     setRewardRatiodata({
																			//         ...rewardratioData,
																			//         expirationRule: {
																			//             ...rewardratioData.expirationRule,
																			//             afterSpecificNumber: parseNumeric(e.target.value),
																			//         },
																			//     })
																			// }
																			onChange={onChange}
																		/>
																	</div>
																</div>
																<div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
																	<div className="form-group">
																		<label>After</label>
																		<SelectValidator
																			placeholder="Select"
																			className="custom-ReactSelect bordered"
																			name="afterDay"
																			validators={["required"]}
																			errorMessages={["Please select a value "]}
																			value={selectValueGetter(option.optionAfter, data.afterDay)}
																			options={option.optionAfter}
																			// onChange={(e)=>setData({...data},data.afterDay=e.value)}
																			onChange={onChangeSelect}
																		/>
																	</div>
																</div>
															</>
														) : (
															<>
																<div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
																	<div className="form-group">
																		<label>On (Specific Date)</label>
																		<TextValidator
																			placeholder="365"
																			className="form-control"
																			name="onspecificdate"
																			type="date"
																			onChange={onChange}
																			value={data.onspecificdate}
																			validators={["required"]}
																			errorMessages={["Please select a date "]}
																			// onChange={(e) =>
																			//     setRewardRatiodata({
																			//         ...rewardratioData,
																			//         expirationRule: {
																			//             ...rewardratioData.expirationRule,
																			//             onSpecificDate: e.target.value,
																			//         },
																			//     })
																			// }
																		/>
																	</div>
																</div>
															</>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>

									<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
										<div className="button-section">
											<button type="button" className="btn btn-danger" onClick={onCancel}>
												Cancel
											</button>
											<button type="submit" className="btn btn-primary">
												Update
											</button>
										</div>
									</div>
								</div>
							</ValidatorForm>
						</div>
					</div>
				</div>
			</div>
		</>
	);
});

export default CreateSignupRuleTab;
